var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',_vm._b({staticClass:"pa-0 ma-0",attrs:{"menu-props":{ offsetY: true },"variant":"underlined"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-select',_vm.mergedAttributes,false))
}
var staticRenderFns = []

export { render, staticRenderFns }